(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("map-arbitrary-extent", [], factory);
	else if(typeof exports === 'object')
		exports["map-arbitrary-extent"] = factory();
	else
		root["map-arbitrary-extent"] = factory();
})(self, function() {
return 